const $ = jQuery.noConflict();

$(document).ready(function() {

    if ($('.lg-filter').length) {

        const $filterCols = $('.lg-filter-col');
        const $filterMenus = $('.lg-filter-menu');

        $('.lg-filter-col .lg-filter-item').on('click', function() {

            const $parentCol = $(this).parent();

            $filterCols.not($parentCol).removeClass('active');

            $filterMenus.not($(this).next()).stop().slideUp();

            if ($parentCol.hasClass('active')) {

                $(this).next('.lg-filter-menu').slideUp();
                $parentCol.removeClass('active');

            } else {

                $(this).next('.lg-filter-menu').slideDown();
                $parentCol.addClass('active');

            }

        });

        $('.lg-search').on('click', function() {

            $filterCols.removeClass('active');
            $filterMenus.slideUp();

        });

        $(document).on('click touchstart', function(e) {

            const $target = $(e.target);

            if (
                !$target.closest('.lg-filter-col').length &&
                !$target.closest('.lg-search').length
            ) {

                $filterCols.removeClass('active');
                $filterMenus.slideUp();

            }

        });

        $(document).on('keydown', function(e) {

            if (e.key === 'Escape') {

                $filterCols.removeClass('active');
                $filterMenus.slideUp();

            }

        });

    }

});